{
  "name": "tinite-mobile",
  "version": "2.0.1",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "uat": "ng serve --port 4200 --configuration uat",
    "dev": "ng serve --port 4201 --configuration local",
    "mock": "ng serve --port 4202 --configuration mock",
    "build": "ng build",
    "build:prod": "node scripts/build-with-env.mjs --configuration production",
    "build:uat": "node scripts/build-with-env.mjs --configuration uat",
    "watch": "ng build --watch --configuration development",
    "test": "jest",
    "lint": "eslint .",
    "format": "prettier --write \"src/**/*.{ts,html,scss}\"",
    "cap:sync": "npx cap sync",
    "cap:run:ios": "npx cap run ios",
    "cap:run:android": "npx cap run android",
    "mobile:sync:prod": "npm run build:prod && npx cap sync",
    "mobile:sync:uat": "npm run build:uat && npx cap sync",
    "generate:pwa-icons": "node scripts/gen-pwa-icons.mjs",
    "generate:api": "node scripts/filter-api-spec.mjs && npx ng-openapi-gen --config ng-openapi-gen.json",
    "e2e": "cross-env TS_NODE_PROJECT=tsconfig.e2e.json cucumber-js \"docs/features/**/*.feature\"",
    "e2e:mvp": "cross-env TS_NODE_PROJECT=tsconfig.e2e.json cucumber-js \"docs/features/**/*.feature\" --tags @mvp",
    "e2e:tags": "cross-env TS_NODE_PROJECT=tsconfig.e2e.json cucumber-js \"docs/features/**/*.feature\" --tags",
    "sentry:sourcemaps": "node scripts/sentry-sourcemaps.mjs",
    "sentry:sourcemaps:native": "node scripts/sentry-sourcemaps.mjs --native",
    "postinstall": "patch-package"
  },
  "private": true,
  "packageManager": "npm@10.9.7",
  "overrides": {
    "uuid": "^11.1.1"
  },
  "dependencies": {
    "@angular/animations": "21.2.17",
    "@angular/common": "^21.2.16",
    "@angular/compiler": "^21.2.16",
    "@angular/core": "^21.2.16",
    "@angular/forms": "21.2.17",
    "@angular/platform-browser": "21.2.17",
    "@angular/platform-browser-dynamic": "21.2.17",
    "@angular/router": "21.2.17",
    "@angular/service-worker": "^21.2.17",
    "@cantoo/pdf-lib": "^2.7.3",
    "@capacitor/android": "8.4.1",
    "@capacitor/app": "8.1.1",
    "@capacitor/barcode-scanner": "^3.0.2",
    "@capacitor/camera": "8.2.0",
    "@capacitor/cli": "8.4.1",
    "@capacitor/core": "8.4.1",
    "@capacitor/device": "^8.0.2",
    "@capacitor/geolocation": "^8.2.0",
    "@capacitor/ios": "8.4.1",
    "@capacitor/network": "^8.0.1",
    "@capacitor/preferences": "^8.0.1",
    "@formio/angular": "11.0.4",
    "@formio/js": "5.4.1",
    "@ionic/angular": "8.8.12",
    "@ionic/core": "8.8.12",
    "@ionic/pwa-elements": "^3.4.0",
    "@ng-select/ng-select": "^21.8.2",
    "@sentry/angular": "10.60.0",
    "@sentry/capacitor": "^4.2.0",
    "@sentry/cli": "^2.58.6",
    "@tabler/icons-webfont": "^3.44.0",
    "@types/crypto-js": "^4.2.2",
    "@types/jszip": "^3.4.0",
    "@zxing/browser": "^0.2.0",
    "@zxing/library": "^0.21.3",
    "capacitor-native-settings": "^8.1.0",
    "capacitor-secure-storage-plugin": "^0.13.0",
    "crypto-js": "^4.2.0",
    "exifr": "^7.1.3",
    "jszip": "^3.10.1",
    "lodash": "^4.18.1",
    "ngx-bootstrap": "21.2.1",
    "pdfjs-dist": "^6.1.200",
    "piexifjs": "^1.0.6",
    "rxjs": "~7.8.2",
    "tslib": "^2.3.0",
    "zone.js": "^0.16.2"
  },
  "devDependencies": {
    "@angular-eslint/builder": "^21.4.0",
    "@angular-eslint/eslint-plugin": "^21.4.0",
    "@angular-eslint/eslint-plugin-template": "^21.4.0",
    "@angular-eslint/template-parser": "^21.4.0",
    "@angular/build": "21.2.17",
    "@angular/cli": "21.2.17",
    "@angular/compiler-cli": "^21.2.16",
    "@cucumber/cucumber": "^13.0.0",
    "@playwright/test": "1.61.1",
    "@resvg/resvg-js": "^2.6.2",
    "@types/jest": "^30.0.0",
    "@types/js-yaml": "^4.0.9",
    "@types/lodash": "^4.17.24",
    "@typescript-eslint/eslint-plugin": "8.62.0",
    "@typescript-eslint/parser": "8.62.0",
    "cross-env": "^10.1.0",
    "eslint": "10.5.0",
    "eslint-plugin-sonarjs": "4.1.0",
    "jest": "^30.4.2",
    "jest-environment-jsdom": "^30.4.1",
    "jest-preset-angular": "16.2.0",
    "js-yaml": "^4.2.0",
    "jsdom": "^28.1.0",
    "ng-openapi-gen": "^1.0.5",
    "patch-package": "^8.0.1",
    "prettier": "3.8.5",
    "ts-jest": "^29.4.11",
    "ts-node": "^10.9.2",
    "typescript": "~5.9.3",
    "vitest": "4.1.9"
  },
  "allowScripts": {
    "@sentry/cli@2.58.6": true,
    "@sentry/capacitor@4.2.0": true,
    "esbuild@0.28.1": true
  },
  "browserslist": [
    "Chrome >=111",
    "ChromeAndroid >=61",
    "Firefox >=112",
    "Firefox ESR",
    "Edge >=111",
    "Safari >=16.4",
    "iOS >=16.4"
  ]
}
